import { FC } from 'react';
import { HomeTeamsContainer } from './MyTeams.style';

export const MyTeamsLoader: FC = () => (
	<HomeTeamsContainer
		role="status"
		className="w-full animate-pulse divide-y divide-gray-200 rounded-3xl border border-gray-200 px-4 shadow dark:divide-gray-700 dark:border-gray-700"
	>
		<div className="flex items-center justify-between gap-4 py-3">
			<div className="h-5 w-1/2 rounded-full bg-gray-300 dark:bg-gray-600"></div>
			<div className="h-5 w-1/2 rounded-full bg-gray-300 dark:bg-gray-600"></div>
		</div>
		<div className="tournaments__standing text__default">
			{Array.from(new Array(20)).map((e, i) => {
				return (
					<div className="flex items-center justify-between py-2" key={i}>
						<div className="h-2.5 w-5 rounded-full bg-gray-300 dark:bg-gray-700"></div>
						<div className="h-3 w-20 rounded-full bg-gray-300 dark:bg-gray-700"></div>
						<div className="h-2.5 w-5 rounded-full bg-gray-300 dark:bg-gray-700"></div>
					</div>
				);
			})}
		</div>
	</HomeTeamsContainer>
);
